import './styles.css';

const SummaryBar = ({ deposit = 0, invested = 0, profit = 0, roi = 0 }) => {
  return (
    <div className="summary-bar">
      <div className="summary-item">
        <span> Inwestycja</span>
        <strong>${deposit}</strong>
      </div>
      <div className="summary-item">
        <span> Kapitał Zaangażowany</span>
        <strong>${invested.toFixed(2)}</strong>
      </div>
      <div className="summary-item">
        <span> Zysk</span>
        <strong>${profit.toFixed(2)}</strong>
      </div>
      {/* <div className="summary-item">
        <span> Średnie ROI</span>
        <strong>{roi.toFixed(2)}%</strong>
      </div> */}
    </div>
  );
};

export default SummaryBar;
